export enum AdminRole {
  // Super admin is for Zentact employees use only
  SUPER_ADMIN = 'SuperAdmin',
  TENANT_ADMIN = 'TenantAdmin',
  SALES_AGENT = 'SalesAgent',
  FINANCE_MANAGER = 'FinanceManager',
  DEVELOPER = 'Developer',
  SUPPORT = 'Support',
}

/**
 * Type guard to check if a string is a valid AdminRole
 */
export const isAdminRole = (role: string): role is AdminRole => {
  return Object.values(AdminRole).includes(role as AdminRole);
};
